import React, { useState } from 'react';
import { Navbar, Nav, NavDropdown, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
// import Buttonn from '../pages/Button';

const Header = () => {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [isSearchOpen] = useState(false);
  // const [scrolling, setScrolling] = useState(false); 

  // Function to handle scroll events
  // const handleScroll = () => {
  //   const scrollPosition = window.scrollY; 
  //   if (scrollPosition > 100) { 
  //     setScrolling(true); 
  //   } else {
  //     setScrolling(false); 
  //   }
  // };

  // Add event listener on component mount and clean up on unmount
  // useEffect(() => {
  //   window.addEventListener('scroll', handleScroll);
  //   return () => {
  //     window.removeEventListener('scroll', handleScroll);
  //   };
  // }, []);

  const toggleNav = () => {
    setIsNavOpen(!isNavOpen);
  };

  // const toggleSearch = () => {
  //   setIsSearchOpen(!isSearchOpen);
  // };

  return (
    // <header className={`header ${scrolling ? 'sticky-header' : ''}`}>
    <header>
      {/* Header Top */}
      <div className="header-top bg-darkk text-center pt-2">
        <div className="container">
          <div className="row justify-content-center justify-content-xl-between align-items-center">
            <div className="col-auto">
              <div className="header-top-contact text-center">
                <ul className='anchor d-md-flex'>
                  <li className='px-md-5 fw-bold'>
                    <a className='text-white' href="tel:+917353109555">
                      <i className="fas fa-phone-volume  text-white"></i> +91 7353109555
                    </a>
                  </li>
                  <li className='px-md-5 fw-bold'>
                    <a className='text-white' href="tel:+917090597555 ">
                      <i className="fas fa-phone-volume  text-white"></i> +91 7090597555
                    </a>
                  </li>
                   <li className='px-md-5 fw-bold'>
                    <a className='text-white' href="tel:+917887774499 ">
                      <i className="fas fa-phone-volume  text-white"></i> +91 7887774499
                    </a>
                  </li>
                  <li>
                    <a
  className="text-white"
  href="mailto:booking@bushireinpune.com"
  aria-label="Email Amruta Travels"
>
                      <i className="far fa-envelope text-white"></i>
                      <span className='text-white fw-bold'> booking@bushireinpune.com</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* Main Navigation */}
      <div className="main-navigation">
        <Navbar expand="lg">
          <Container>
            <Link to="/" aria-label="Bus Hire in Pune Home">
  <img
    src="/images/logo.png"
    className="logoo"
    alt="Bus Hire in Pune - Amruta Travels"
    width="180"
    height="70"
    loading="eager"
    decoding="async"
  />
</Link>
            <Navbar.Toggle
  aria-controls="main_nav"
  aria-label="Toggle navigation menu"
  onClick={toggleNav}
>
  <i className="fas fa-bars darkcolor"></i>
</Navbar.Toggle>

            <Navbar.Collapse id="main_nav" className={isNavOpen ? "show" : ""}>
              <Nav className="mx-auto">
                <Nav.Link href="/" className='fw-bold nav-item'>Home</Nav.Link>
                <NavDropdown title="About Us" id="about-us-dropdown" className='fw-bold'>
                  <NavDropdown.Item href="/about" className='fw-bold nav-item'>About Us</NavDropdown.Item>
                  <NavDropdown.Item href="/term-condition" className='fw-bold nav-item'>Term & Condition</NavDropdown.Item>
                  <NavDropdown.Item href="/privacy-policy" className='fw-bold '>Privacy Policy</NavDropdown.Item>
               <NavDropdown.Item href="/Faqs" className='fw-bold '>Faqs </NavDropdown.Item>
                </NavDropdown>
                <Nav.Link href="/services" className='fw-bold nav-item'>Services</Nav.Link>
                <Nav.Link href="/our-fleet" className='fw-bold nav-item'>Our Fleet</Nav.Link>
                <Nav.Link href="/packages" className='fw-bold nav-item'>Packages</Nav.Link>
                <Nav.Link href="/booking" className='fw-bold nav-item'> Booking</Nav.Link>
                <Nav.Link href="/gallery" className='fw-bold nav-item'>Gallery</Nav.Link>
                <NavDropdown title="Contact Us" id="contact-dropdown" className='fw-bold'>
                  <NavDropdown.Item href="/contact-us" className='fw-bold nav-item'>Contact Us</NavDropdown.Item>
                  <NavDropdown.Item href="/enquiry" className='fw-bold'>Enquiry</NavDropdown.Item>
                  <NavDropdown.Item href="/Careers" className='fw-bold'>Careers</NavDropdown.Item>
                </NavDropdown>
                <Nav.Link href="/blog" className='fw-bold nav-item'>Blog</Nav.Link>
              </Nav>
              {/* <Buttonn/> */}
            </Navbar.Collapse>
            
          </Container>
         
        </Navbar>
      </div>

      {/* Search Area */}
      {isSearchOpen && (
        <div className="search-area">
          <form action="#">
            <div className="form-group">
              <input type="text" className="form-control" placeholder="Type Keyword..." />
              <button type="submit" className="search-icon-btn">
                <i className="far fa-search"></i>
              </button>
            </div>
          </form>
        </div>
      )}
    </header>
  );
};

export default Header;






